import { useState } from "react";
import {
  getItem,
  setItem,
  deleteItem,
  clearItem,
} from "../services/localStorage";

export function useLocalStorage(key, initialValue) {
  const [loading, setLoading] = useState(true);
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = getItem(key);
      const newValue = item || initialValue;
      return newValue;
    } catch (error) {
      console.error(error);
      return initialValue;
    }
  });

  const setValue = (valueToStore) => {
    try {
      setStoredValue(valueToStore);
      const value = valueToStore;
      if (!value) return deleteItem(key);

      setItem(key, value);
    } catch (error) {
      console.error(error);
    }
  };

  const clear = () => {
    clearItem();
    setStoredValue(initialValue);
    setLoading(false);
  };

  const remove = () => deleteItem(key);

  return [storedValue, setValue, loading, remove, clear];
}
